module.exports = __webpack_public_path__ + "img/w3_phone_dark.e3551682.png";